import { TransaccionModel } from "../transaccion.model";
import { IResponse } from "src/app/pages/base/interfaces";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ArqueoCajaService } from "src/app/services/cobranza/arqueo-caja.service";


export class ArqueoCaja extends TransaccionModel {

    public static RECORD_NAME = 'arqueos_caja';
    public static CODIGO_REGISTRO = 'arqueo_caja';
    public static CODIGO_MODULO = 'cobranza';
    public static NOMBRE_SINGULAR = 'Arqueo de Caja';
    public static NOMBRE_PLURAL = 'Arqueos de Caja';
    

    public static ESTADO_ABIERTO = 1;
    public static ESTADO_CERRADO = 2;
    public static ENABLE_FIELDS: string[] = ['fecha_transaccion','fecha_cierre'];
    public static DISABLE_FIELDS: string[] = ['fecha_transaccion','fecha_cierre'];
    
    public static ESTADOS = [
        { valor: 1, nombre: 'ABIERTO' },
        { valor: 2, nombre: 'CERRADO' },
    ];
    

    private _idEmpresa:                     number;
    private _nombreEmpresa:                 string;
    private _idSucursal:                    number;
    private _nombreSucursal:                string;
    private _idCaja:                        number;
    private _nombreCaja:                    string;
    private _importeApertura:               number;
    private _fechaCierre:                   Date;
    private _estado:                        number;
    private _totalIngreso:                  number;
    private _totalEgreso:                   number;
    private _impreso:                       boolean;
    private _cantidadIngreso:               number;
    private _cantidadEgreso:                number;

    constructor() {
        super();
        const currentUser = this.seguridad.getCurrentUser();
        this._idEmpresa = currentUser.id_empresa;
        this._nombreEmpresa = currentUser.empresa.nombre;
        this._idSucursal = currentUser.id_sucursal;
        this._nombreSucursal = currentUser.sucursal.nombre;
        this._importeApertura = 0;
        this._estado = ArqueoCaja.ESTADO_ABIERTO;
        this._totalIngreso = 0;
        this._totalEgreso = 0;
        this._cantidadIngreso = 0;
        this._cantidadEgreso = 0;
        this._fechaCierre = new Date();
        this._impreso = false;
    }

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa; }
    public get idEmpresa(): number { return this._idEmpresa; }

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa; }
    public get nombreEntidad(): string { return this._nombreEmpresa; }

    public set idSucursal( idSucursal: number ) { this._idSucursal = idSucursal; }
    public get idSucursal(): number { return this._idSucursal; }

    public set nombreSucursal( nombreSucursal: string ) { this._nombreSucursal = nombreSucursal; }
    public get nombreSucursal(): string { return this._nombreSucursal; }

    public set nombreCaja( nombreCaja: string ) { this._nombreCaja = nombreCaja };
    public get nombreCaja(): string { return this._nombreCaja };

    public set idCaja( idCaja: number ) { this._idCaja = idCaja };
    public get idCaja(): number { return this._idCaja };
    
    public set importeApertura( importeApertura: number ) { this._importeApertura = importeApertura };
    public get importeApertura(): number { return this._importeApertura };

    public set fechaCierre( fechaCierre: Date ) { this._fechaCierre = fechaCierre; }
    public get fechaCierre(): Date { return this._fechaCierre;}
    
    public set estado( estado: number ) { this._estado = estado };
    public get estado(): number { return this._estado };
    
    public set totalIngreso( totalIngreso: number ) { this._totalIngreso = totalIngreso; }
    public get totalIngreso(): number { return this._totalIngreso;}

    public set totalEgreso( totalEgreso: number ) { this._totalEgreso = totalEgreso; }
    public get totalEgreso(): number { return this._totalEgreso;}
    
    public set impreso( impreso: boolean ) { this._impreso = impreso; }
    public get impreso(): boolean { return this._impreso;}
    
    public set cantidadIngreso( cantidadIngreso: number ) { this._cantidadIngreso = cantidadIngreso; }
    public get cantidadIngreso(): number { return this._cantidadIngreso;}


    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'nro_transaccion', label: 'Nro. Trx.', type: 'number' },
            { field: 'fecha_transaccion', label: 'Fecha Trx.', type: 'date' },
        ]
    }

    override async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );        
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.empresa.nombre;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.sucursal.nombre;
        this._nombreSucursal = objeto.sucursal.nombre;
        this._idCaja = objeto.id_caja;
        this._nombreCaja = objeto.caja.nombre;
        this._importeApertura = objeto.importe_apertura;
        this._fechaCierre = objeto.fecha_cierre ? new Date(objeto.fecha_cierre): objeto.fecha_cierre;;
        this._estado = objeto.estado;
        this._impreso = objeto.impreso;
        this._totalIngreso = objeto.total_ingreso;
        this._totalEgreso = objeto.total_egreso;
        this._cantidadIngreso = objeto.cantidad_ingreso;
        this._cantidadEgreso = objeto.cantidad_egreso;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa, Validators.required));
        fg.addControl("id_sucursal", new FormControl(this._idSucursal, Validators.required));
        fg.addControl("nombre_sucursal", new FormControl(this._nombreSucursal, Validators.required));
        fg.addControl("id_caja", new FormControl(this._idCaja));
        fg.addControl("nombre_caja", new FormControl(this._nombreCaja));
        fg.addControl("importe_apertura", new FormControl(this._importeApertura));
        fg.addControl("fecha_cierre", new FormControl(this._fechaCierre));
        fg.addControl("estado", new FormControl(this._estado));
        fg.addControl("total_ingreso", new FormControl(this._totalIngreso));
        fg.addControl("total_egreso", new FormControl(this._totalEgreso));
        fg.addControl("impreso", new FormControl(this._impreso));
        fg.addControl("cantidad_ingreso", new FormControl(this._cantidadIngreso));
        fg.addControl("cantidad_egreso", new FormControl(this._cantidadEgreso));
        return fg;
    }

    override async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.nombre_sucursal;
        this._idCaja = objeto.id_caja;
        this._nombreCaja = objeto.nombre_caja;
        this._importeApertura = objeto.importe_apertura;
        this._fechaCierre = objeto.fecha_cierre ? new Date(objeto.fecha_cierre): objeto.fecha_cierre;;
        this._estado = objeto.estado;
        this._impreso = objeto.impreso;
        this._totalIngreso = objeto.total_ingreso;
        this._totalEgreso = objeto.total_egreso;
        this._cantidadIngreso = objeto.cantidad_ingreso;
        this._cantidadEgreso = objeto.cantidad_egreso;
    }

    override async guardar( service: ArqueoCajaService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    override async actualizar( service: ArqueoCajaService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    override async eliminar( service: ArqueoCajaService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}